import React from 'react';
import "./index.scss";
import Icon from "components/Icon";
// import { Button } from 'react-bootstrap';

interface ILoadPageProps{
  textLoad?: string;
  textError?: string;
  error?: boolean;
}

export default function LoadPage({
  textLoad,
  textError,
  error
}:ILoadPageProps){
  return (
    <div className="load-page-area">
      <div className="load-page">
        {
          error
          ?
          <div className="icon-bug"><Icon name="bug"/></div>
          :
          <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        }
        <label>{error?textError:textLoad}</label>
      </div>
      {/* <Button>Voltar para a pagina principal</Button> */}
    </div>
  );
}